import styled from "styled-components";

export const PageWrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  display: grid;
  place-items: center;
  background: #f3f4f6;
  padding: 40px 16px;
  box-sizing: border-box;
`;

export const Card = styled.div`
  background: white;
  border-radius: 12px;
  padding: 48px 56px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  width: 100%;
  max-width: 480px;
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 32px 24px;
  }
`;

export const SetupWrapper = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0;
  justify-content: center;
  align-items: center;
`;

export const FormTitle = styled.h2`
  margin: 0 0 8px 0;
  font-size: 24px;
  color: #1e293b;
  text-align: center;
  font-weight: 600;
  font-family: 'Mulish', sans-serif;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
  width: 100%;
`;

export const Label = styled.label`
  font-size: 14px;
  color: #64748b;
  text-align: left;
  font-weight: 500;
  font-family: 'Mulish', sans-serif;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  font-family: 'Mulish', sans-serif;
  box-sizing: border-box;

  &:hover {
    border-color: #cbd5e1;
  }

  &:focus {
    border-color: #2c3e50;
    box-shadow: 0 0 0 3px rgba(44, 62, 80, 0.1);
  }

  &::placeholder {
    color: #cbd5e1;
  }
`;

export const Buttons = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  width: 100%;
`;
